import { render, staticRenderFns } from "./monitoria.vue?vue&type=template&id=0f37469a&"
import script from "./monitoria.js?vue&type=script&lang=js&"
export * from "./monitoria.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports